import React, { FC, useState, useLayoutEffect } from 'react';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { ShippingAddressType } from '../types/shipping-address-type';
import { Address } from '../components/shipping-address/Address';
import { useShippingAddress } from '../hooks/use-shipping-address';

export const ShippingAddress: FC<{ setting: Setting }> = ({ setting }) => {
  const [subscriptionContractId, setSubscriptionContractId] = useState('');
  const [shippingAddress, setShippingAddress] = useState<ShippingAddressType>();

  useLayoutEffect(() => {
    const height = document.querySelector('body')!.scrollHeight

    setting.resize(height)
  }, [shippingAddress])

  useShippingAddress(setting, setSubscriptionContractId, setShippingAddress);

  return (
    <>
      <div className={classes.mypage_subsc_container}>
        <Address shippingAddress={shippingAddress} />
      </div>
    </>
  );
};
